import React from 'react';
import { TabsProps } from 'antd';

import WorkTableCompleted from '@totem/components/surveyV2/work/WorkTableCompleted';
import WorkTableIncomplete from '@totem/components/surveyV2/work/WorkTableIncomplete';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';

const styles = {
  tabContainer: {
    paddingRight: '2rem',
    paddingLeft: '2rem',
  },
};

const WorkTabs = () => {
  const tabItems: TabsProps['items'] = [
    {
      key: 'incomplete',
      label: 'Incomplete',
      children: <WorkTableIncomplete />,
    },
    {
      key: 'complete',
      label: 'Complete',
      children: <WorkTableCompleted />,
    },
  ];

  return (
    <IBTabs
      defaultActiveKey="incomplete"
      items={tabItems}
      style={styles.tabContainer}
    />
  );
};

export default WorkTabs;
